import React from 'react';
import { useNavigate } from 'react-router-dom';

const BackButton = () => {
    const navigate = useNavigate();

    return (
        <button className="global-back-btn" onClick={() => navigate(-1)} aria-label="Go Back">
            <span className="back-icon">←</span> Back
        </button>
    );
};

export default BackButton;
